import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  fetchTraerContratacionIngreso,
  desSeleccionarContrato,
  fetchTraerContratacionIngresoXPresupuesto,
  desSeleccionarPresupuesto,
} from "../../actions/contrataciones/contrataciones";
import { fetchConToken } from "../../helpers/fetch";
import { fetchSubTipoEfectores } from "../../actions/tipoSubtipoEfectores";
import { setDataContrato } from "../../actions/contrataciones/contrataciones";
import { startAlerta } from "../../actions/ui/alertas";
import { TIPO_EFECTORES } from "../../utils/constants";
import { contratacionesActions } from "../../reducers/contrataciones/contratacionesReducer";

const fechaActual = new Date();

export const ContratacionesIngreso = ({ nuevo, setNuevo, ...props }) => {
  const dispatch = useDispatch();

  const { tipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores);

  const [idTipoEfector, setIdTipoEfector] = useState("");
  const [cuit, setCuit] = useState("");
  const { presupuesto } = useSelector((state) => state.contrataciones);

  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );
  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
  }, []);

  const onChangeCuit = (e) => {
    let reg = new RegExp("^[0-9]+$");

    if (
      e.target.value === "" ||
      reg.test(e.target.value) ||
      isNaN(e.target.value)
    ) {
      if (isNaN(e.target.value)) {
        setCuit("");
      } else {
        setCuit(e.target.value);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event && event.key === "Enter") {
      traerDataContrato();
    }
  };

  useEffect(() => {
    if (presupuesto) {
      if (presupuesto.idEfectorFacturacion) {
        setInputValue(presupuesto?.idEfectorFacturacion.toString());
        setIdTipoEfector(TIPO_EFECTORES.CONTRATO_PRESTADORES)
        dispatch(fetchTraerContratacionIngresoXPresupuesto(presupuesto.idEfectorFacturacion));
      } else {
        setNuevo(true);
        setCuit(presupuesto.cuitPrestador)
        setIdTipoEfector(TIPO_EFECTORES.CONTRATO_PRESTADORES)
        traerDataContrato(presupuesto.cuitPrestador.toString(), TIPO_EFECTORES.CONTRATO_PRESTADORES);
      }
    }
  }, [presupuesto])

  useEffect(() => {
    let active = true;
    setLoading(true);

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      setLoading(false);
      return undefined;
    }

    (async () => {
      const response = await fetchConToken(`EfectorFacturacion/BusquedaPorIdTipoEfector/${idTipoEfector}?parametros=${inputValue}&nuevo=${nuevo}`);
      const results = await response.json();

      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        newOptions = [...newOptions, ...results];

        setOptions(newOptions);
        setLoading(false);
      }

    })();
    return () => {
      active = false;
    };
  }, [value, inputValue]);

  const resetForm = () => {
    setOptions([]);
  };

  const traerDataContrato = (cuitPrestador, idTipoEfectorPresupuesto) => {
    const cuitContrato = cuitPrestador ? cuitPrestador : cuit
    const idTipoEfectorContrato = idTipoEfectorPresupuesto ? idTipoEfectorPresupuesto : idTipoEfector
    if (cuitContrato.length < 11) {
      dispatch(startAlerta("¡CUIT inválido!", "error"));
    } else if (idTipoEfectorContrato.toString().trim() === "") {
      dispatch(
        startAlerta("Por favor seleccione un Tipo de Contratación", "error")
      );
    } else {
      dispatch(desSeleccionarContrato());
      dispatch(fetchTraerContratacionIngreso({ idTipoEfector: idTipoEfectorContrato, parametro: cuitContrato, nuevo: true }));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(desSeleccionarContrato());
    dispatch(contratacionesActions.acuerdoJudicial(value?.acuerdoJudicial));
    if (nuevo) {
      traerDataContrato();
    } else {
      dispatch(setDataContrato(value));
      resetForm();
    }
  };

  useEffect(() => () => dispatch(desSeleccionarContrato()), []);

  return (
    <Grid item xs={12} sm={5} lg={4} xl={3}>
      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        component={Card}
        style={{ marginTop: "2rem", marginBottom: "2rem" }}
      >
        <Grid container justify="center">
          <Grid item xs={11}>
            <FormControlLabel
              style={{ marginTop: "1rem" }}
              control={
                <Checkbox
                  name="nuevo"
                  checked={nuevo}
                  onChange={(e) => { setNuevo(e.target.checked); setCuit(""); resetForm(); setValue(null); dispatch(desSeleccionarPresupuesto()); }}
                />
              }
              label="Contrato Nuevo"
            />
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={11}>
            <FormControl variant="outlined" margin="normal" fullWidth={true}>
              <InputLabel id="demo-simple-select-outlined">
                Tipo de Contratación
              </InputLabel>
              <Select
                onChange={(e) => setIdTipoEfector(parseInt(e.target.value))}
                value={idTipoEfector}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Tipo de Contratación"
              >
                {tipoEfectores.map((t) => (
                  <MenuItem key={t.idTipoEfector} value={t.idTipoEfector}>
                    {t.descripcionTipoEfector}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={11}>
            {nuevo ? (
              <TextField
                fullWidth
                variant="outlined"
                margin="normal"
                label="CUIT"
                autoComplete={"off"}
                value={cuit}
                onChange={onChangeCuit}
                onKeyPress={handleKeyPress}
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 11);
                }}
              />
            ) : (
              <Autocomplete
                style={{ marginTop: "1rem" }}
                disabled={!idTipoEfector}
                filterOptions={(x) => x}
                options={options}
                autoComplete
                includeInputInList
                filterSelectedOptions
                value={value}
                onChange={(event, newValue) => {
                  setOptions(newValue ? [newValue, ...options] : options);
                  setValue(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                noOptionsText="No hay contrato"
                loadingText="Buscando..."
                loading={loading}
                getOptionLabel={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector ===
                      option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return `${option.razonSocial} ${option.cuit} - ${subTipoEfector}`;
                }}
                renderOption={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector ===
                      option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          color: option.fechaBaja === null || option.fechaBaja >= fechaActual.toISOString() ? "green" : "red",
                        }}
                      >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                    </div>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Cod contrato  |  CUIT  |  Razón Social  |  Nombre Fantasia"
                    fullWidth
                  />
                )}
              />
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Button
            style={{ margin: "1rem 0" }}
            variant="contained"
            color="primary"
            fullWidth
            disabled={(!value && !cuit) || !idTipoEfector}
            onClick={(e) => {
              submitHandler(e);
            }}
          >
            CONTINUAR
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
